import { inject, Injectable } from "@angular/core";

import { BaseHttpService } from "@app/core/services/base-http.service";
import { Observable } from "rxjs";
import { TResponse } from "@app/core/types/response.type";

@Injectable({ providedIn: "root" })
export class OrganisationEntityAccessUserService {
  private readonly http$ = inject(BaseHttpService);

  changeOrganisation(organizationEntityId: string): Observable<TResponse<boolean>> {
    return this.http$.put(`OrganizationEntityAccessUser/change-organization`, {
      organizationEntityId
    });
  }
}
